<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <div class="row">
        <div class="col-10">
          <button
            type="button"
            class="approve btn btn-primary waves-effect waves-light"
            @click="selectAll"
          >
            {{ this.t.t(dictEnum.LBL_SelectAll) }}
          </button>
        </div>
        <div class="col-2 text-right">
          <button
            type="button"
            class="approve btn btn-primary waves-effect waves-light"
            @click="syncUserList"
          >
            {{ this.t.t(dictEnum.MENU_SyncUsertoMizar) }}
          </button>
        </div>
      </div>
      <div class="tab-pane active table-responsive color-table pt-5">
        <v-client-table
          :key="tableKey"
          :data="userList"
          :columns="columns"
          :options="options"
        >
          <template slot="Select" slot-scope="rt">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="`chkBox${rt.row.StaffID}`"
                v-model="checkboxlist"
                :v-id="rt.row.StaffID"
                :value="rt.row.StaffID"
              />
              <label
                class="custom-control-label text-white"
                :for="`chkBox${rt.row.StaffID}`"
              ></label>
            </div>
          </template>
          <template slot="EngName" slot-scope="rt">
            {{ rt.row.EngName + " " + rt.row.EngLastName }}
          </template>
          <template slot="ChiName" slot-scope="rt">
            {{ rt.row.ChiLastName + rt.row.ChiName }}
          </template>
          <template slot="SyncMessage" slot-scope="rt">
            <span
              v-if="rt.row.SyncMessage == 'loading'"
              class="spinner-border spinner-border-sm"
            ></span>
            <span v-else>{{ rt.row.SyncMessage }}</span>
          </template>
        </v-client-table>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import UserService from "@/service/UserService";
import ServerService from "@/service/ServerService";
import Settings from '../../constants/Settings';

export default {
  components: {
    DatePicker,
    moment
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.SyncUsertoMizar,
      Settings: Settings,
      dictEnum: dictEnum,
      serverUrl: "",
      serverToken: "",
      userList: [],
      columns: [
        "Select",
        "ChiName",
        "EngName",
        "Email",
        "JobTitle",
        "SyncMessage"
      ],
      options: {},
      checkboxlist: [],
      tableKey: 0
    };
  },

  methods: {
    async getUserList() {
      const obj = {};
      const response = await UserService.getUsers(obj);
      if (response.data.IsSuccess) {
        this.userList = response.data.Data;
        this.userList.forEach(x => {
          x.SyncMessage = t.t(dictEnum.LBL_NotSynced);
        });
      } else {
        SweetAlertService.warning(response.data.Message);
      }
    },
    async syncUser(username) {
      const index = this.userList.findIndex(x => x.StaffID == username);
      const obj = {
        Url: this.serverUrl,
        AccessToken: this.serverToken,
        user: this.userList[index]
      };
      this.userList[index].SyncMessage = "loading";
      try {
        const res = await UserService.syncUserToMizar(obj);
        if (res.data.IsSuccess) {
          this.userList[index].SyncMessage = t.t(dictEnum.LBL_Synced);
        } else {
          this.userList[index].SyncMessage = t.t(dictEnum.LBL_SyncError);
        }
        this.tableKey++;
      } catch (e) {
        this.userList[index].SyncMessage = e.toString();
        this.tableKey++;
      }
    },
    syncUserList() {
      for (let username of this.checkboxlist) {
        this.syncUser(username);
      }
    },
    async getMizarServerRouter() {
      this.isLoading = true;
      const res = await ServerService.getMizarServerRouter();
      if (res.data.IsSuccess) {
        this.serverUrl = res.data.Data;
        const tokenRes = await ServerService.getMizarToken(this.serverUrl);
        if (tokenRes.data.IsSuccess) {
          this.isLoading = false;
          this.serverToken = tokenRes.data.Data.AccessToken;
        } else {
          this.isLoading = false;
          throw new Error(
            "Mizar authentication failed, please contact technical support."
          );
        }
      } else {
        this.isLoading = false;
        throw new Error("Server not found, please contact technical support.");
      }
    },
    selectAll() {
      this.checkboxlist = this.userList.map(x => x.StaffID);
    }
  },

  mounted() {
    this.options = {
      filterable: false,
      perPageValues: [],
      sortable: [],
      skin: "table table-hover v-midle",
      headings: {
        Select: "",
        EngName: t.t(dictEnum.LBL_Username),
        ChiName: t.t(dictEnum.LBL_UserChiname),
        Email: t.t(dictEnum.LBL_Email),
        JobTitle: t.t(dictEnum.LBL_JobTitle),
        SyncMessage: t.t(dictEnum.LBL_SyncMessage)
      },
      texts: {
        noResults: t.t(dictEnum.LBL_NoData),
        count: ``
      },
      columnsClasses: {}
    };
    this.getUserList();
    this.getMizarServerRouter();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/S060000-Admin/S060400-SyncUserToMizar.vue